import React from 'react';
import SellerInfoBlock from '../seller-info-block/seller-info-block';

const SellerContactCard: React.FC<Props> = ({
    isMobileCardsLayout,
    isPurchaseAvailable,
    setIsBuyerProtectionOpen,
}) => {
    return (
        <SellerInfoBlock
            isMobileCardsLayout={isMobileCardsLayout}
            isPurchaseAvailable={isPurchaseAvailable}
            setIsBuyerProtectionOpen={setIsBuyerProtectionOpen}
        />
    );
};

interface Props {
    isMobileCardsLayout: boolean;
    isPurchaseAvailable?: boolean;
    setIsBuyerProtectionOpen?: (isOpen: boolean) => void;
}

export default SellerContactCard;
